import mergeVariables from '../../../fe-brary-internals/merge-variables';
var neutrals = () => ({
  colour: {
    white: '#fff',
    black: '#000',
    neutral50: '#FAFCFD',
    neutral100: '#F1F5FA',
    neutral200: '#E3E9F2',
    neutral300: '#CCD4E3',
    neutral400: '#A0AFCB',
    neutral500: '#7285A5',
    neutral600: '#455E87',
    neutral700: '#354A6C',
    neutral800: '#102B56',
    neutral900: '#0B2047'
  }
});
var neutralTexts = context => ({
  colour: {
    neutral50Text: context.colour.neutral900,
    neutral100Text: context.colour.neutral900,
    neutral200Text: context.colour.neutral900,
    neutral300Text: context.colour.neutral900,
    neutral400Text: context.colour.neutral900,
    neutral500Text: context.colour.white,
    neutral600Text: context.colour.white,
    neutral700Text: context.colour.white,
    neutral800Text: context.colour.white,
    neutral900Text: context.colour.white
  }
});
var palette = context => ({
  colour: {
    primaryLight: context.colour.allhomesNavy800,
    primary: context.colour.allhomesNavy900,
    primaryDark: '#071939',
    primaryLightText: context.colour.white,
    primaryText: context.colour.white,
    primaryDarkText: context.colour.white,
    secondaryLight: context.colour.allhomesRed600,
    secondary: context.colour.allhomesRed700,
    secondaryDark: context.colour.allhomesRed900,
    secondaryLightText: context.colour.white,
    secondaryText: context.colour.white,
    secondaryDarkText: context.colour.white,
    accentLight: context.colour.allhomesPomegranate400,
    accent: context.colour.allhomesPomegranate500,
    accentDark: context.colour.allhomesPomegranate600,
    accentLightText: context.colour.white,
    accentText: context.colour.white,
    accentDarkText: context.colour.white
  }
});
var namedColours = context => ({
  colour: {
    // Allhomes has no green or aqua in our brand, overriding
    brandGreen25: context.colour.allhomesRed50,
    brandGreenLight: context.colour.allhomesRed400,
    brandGreen: context.colour.allhomesRed700,
    brandGreenDark: context.colour.allhomesRed900,
    brandOrangeLight: context.colour.allhomesOrange100,
    brandOrange: context.colour.allhomesOrange400,
    brandOrangeDark: '#f74a23',
    brandYellowLight: context.colour.allhomesYellow100,
    brandYellow: context.colour.allhomesYellow400,
    brandYellowDark: '#ffa200',
    brandAquaLight: context.colour.allhomesRed200,
    brandAqua: context.colour.allhomesRed400,
    brandPurpleLight: context.colour.allhomesPurple100,
    brandPurple: context.colour.allhomesPurple400,
    brandBlueLight: context.colour.allhomesCeruleanblue100,
    brandBlue: context.colour.allhomesCeruleanblue400,
    brandBlueDark: context.colour.allhomesNavy900
  }
});
export default (context => mergeVariables(neutrals, neutralTexts, palette, namedColours)(context));